var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-list",class:{ right: _vm.right, popup:_vm.popup },style:({ height: _vm.height + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }